import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useAuth from '../navigation/AuthContext';

export default function NavBar() {
  const auth = useAuth();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h3" component="h3" sx={{ flexGrow: 1 }}>
            ReTrack Backoffice
          </Typography>
          <Button color="inherit" onClick={auth.signout}>Logout</Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}